export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Long: { input: number; output: number; }
};

export type AnnouncementChanged = {
  __typename?: 'AnnouncementChanged';
  active: Scalars['Boolean']['output'];
  changeDate: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  licensedTerritories: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CheckoutBalanceChangedPayload = {
  __typename?: 'CheckoutBalanceChangedPayload';
  currency: Scalars['String']['output'];
  nonPayableBalance: Scalars['Long']['output'];
  payableBalance: Scalars['Long']['output'];
  /** e.g. order ID or funding ID */
  reference: Scalars['String']['output'];
  type: PaymentType;
};

export type CheckoutBonusChangedPayload = {
  __typename?: 'CheckoutBonusChangedPayload';
  code: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  productId: Scalars['String']['output'];
};

export type DrawChangePayload = {
  __typename?: 'DrawChangePayload';
  cause: DrawChangedCause;
  closingDate: Scalars['DateTime']['output'];
  drawDate: Scalars['DateTime']['output'];
  drawId: Scalars['String']['output'];
  licensedTerritory: Scalars['String']['output'];
  lotteryId: Scalars['String']['output'];
};

export enum DrawChangedCause {
  DrawDatesChange = 'DrawDatesChange',
  Evaluation = 'Evaluation',
  JackpotsChange = 'JackpotsChange',
  PrizesChange = 'PrizesChange'
}

export type HighFrequencyDrawUpdatePayload = {
  __typename?: 'HighFrequencyDrawUpdatePayload';
  drawNumber: Scalars['Int']['output'];
};

export type HighFrequencyOrderChangePayload = {
  __typename?: 'HighFrequencyOrderChangePayload';
  drawNumber?: Maybe<Scalars['Int']['output']>;
  orderId: Scalars['String']['output'];
  status: HighFrequencyOrderStatus;
};

export enum HighFrequencyOrderStatus {
  Cancelled = 'CANCELLED',
  Evaluated = 'EVALUATED',
  Printed = 'PRINTED'
}

export enum OrderState {
  Failed = 'FAILED',
  Successful = 'SUCCESSFUL'
}

export type OrderStateChangedPayload = {
  __typename?: 'OrderStateChangedPayload';
  /** e.g. order ID or funding ID */
  reference: Scalars['String']['output'];
  state: OrderState;
};

export enum PaymentType {
  Funding = 'Funding',
  Order = 'Order'
}

export type PlaySlipChangePayload = {
  __typename?: 'PlaySlipChangePayload';
  id: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  subscription: Scalars['Boolean']['output'];
  type: PlaySlipChangeType;
};

export enum PlaySlipChangeType {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Ordered = 'ORDERED',
  Purchased = 'PURCHASED'
}

export type PlayerSignupFinishedPayload = {
  __typename?: 'PlayerSignupFinishedPayload';
  playerId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  ping: Scalars['String']['output'];
};

export type ScratchcardOrderReadyPayload = {
  __typename?: 'ScratchcardOrderReadyPayload';
  gameName: Scalars['String']['output'];
  licensedTerritory: Scalars['String']['output'];
  numberOfCards: Scalars['Int']['output'];
  orderId: Scalars['String']['output'];
  titleColor: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  announcementChanged: AnnouncementChanged;
  checkoutBalanceChanges: CheckoutBalanceChangedPayload;
  checkoutBonusChanges: CheckoutBonusChangedPayload;
  drawChanges: DrawChangePayload;
  /** @deprecated Use drawChanges instead */
  drawDateChanges: DrawChangePayload;
  highFrequencyOrderChanges: HighFrequencyOrderChangePayload;
  highFrequencyResultsAndWinnersUpdates: HighFrequencyDrawUpdatePayload;
  orderStateChanges: OrderStateChangedPayload;
  playSlipChanges: PlaySlipChangePayload;
  playerSignupFinished: PlayerSignupFinishedPayload;
  scratchcardOrdersReady: ScratchcardOrderReadyPayload;
};


export type SubscriptionAnnouncementChangedArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type SubscriptionCheckoutBalanceChangesArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionCheckoutBonusChangesArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionDrawChangesArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type SubscriptionDrawDateChangesArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type SubscriptionHighFrequencyOrderChangesArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionHighFrequencyResultsAndWinnersUpdatesArgs = {
  licensedTerritory: Scalars['String']['input'];
};


export type SubscriptionOrderStateChangesArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionPlaySlipChangesArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionPlayerSignupFinishedArgs = {
  authToken: Scalars['String']['input'];
};


export type SubscriptionScratchcardOrdersReadyArgs = {
  authToken: Scalars['String']['input'];
};

export type TypedGraphQlError = {
  message: Scalars['String']['output'];
};

export type CheckoutBalanceChangesSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type CheckoutBalanceChangesSubscription = { __typename?: 'Subscription', checkoutBalanceChanges: { __typename?: 'CheckoutBalanceChangedPayload', currency: string, nonPayableBalance: number, payableBalance: number, reference: string, type: PaymentType } };

export type CheckoutBonusChangedSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type CheckoutBonusChangedSubscription = { __typename?: 'Subscription', checkoutBonusChanges: { __typename?: 'CheckoutBonusChangedPayload', code: string, playerId: string, productId: string } };

export type OrderStateChangesSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type OrderStateChangesSubscription = { __typename?: 'Subscription', orderStateChanges: { __typename?: 'OrderStateChangedPayload', reference: string, state: OrderState } };

export type PlayerSignupFinishedSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type PlayerSignupFinishedSubscription = { __typename?: 'Subscription', playerSignupFinished: { __typename?: 'PlayerSignupFinishedPayload', playerId: string } };

export type AnnouncementChangedSubscriptionVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type AnnouncementChangedSubscription = { __typename?: 'Subscription', announcementChanged: { __typename?: 'AnnouncementChanged', id: string, title: string, description: string, changeDate: string, active: boolean } };

export type DrawChangesSubscriptionVariables = Exact<{
  licensedTerritory: Scalars['String']['input'];
}>;


export type DrawChangesSubscription = { __typename?: 'Subscription', drawChanges: { __typename?: 'DrawChangePayload', cause: DrawChangedCause, lotteryId: string } };

export type PlaySlipChangesSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type PlaySlipChangesSubscription = { __typename?: 'Subscription', playSlipChanges: { __typename?: 'PlaySlipChangePayload', subscription: boolean } };

export type ScratchcardOrdersReadySubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type ScratchcardOrdersReadySubscription = { __typename?: 'Subscription', scratchcardOrdersReady: { __typename?: 'ScratchcardOrderReadyPayload', orderId: string } };

export type HighFrequencyOrderStateChangesSubscriptionVariables = Exact<{
  accessToken: Scalars['String']['input'];
}>;


export type HighFrequencyOrderStateChangesSubscription = { __typename?: 'Subscription', highFrequencyOrderChanges: { __typename?: 'HighFrequencyOrderChangePayload', orderId: string, status: HighFrequencyOrderStatus } };
